export default __webpack_public_path__ + "static/media/btn-ios.15bd2944.svg";